import { apiClient, apiRouterProvider } from '@/common/utils';
import { Workspace } from '@guud/creative-studio-types';

export const getUserWorkspaces = async () => {
  const workspaces: Workspace[] = await apiClient.get(
    apiRouterProvider.workspacesPath
  );
  return workspaces;
};
